import { createSlice } from "@reduxjs/toolkit";
import {
  addSupport,
  deleteSupport,
  getSupportTickets,
  updateSupport,
} from "../apiActions/supportAction";
import handleApiMessage from "../../utils/handleApiError";

type Support = {
  id: string;
  created_at: string;
  name: string;
};

type SupportState = {
  supportTickets: Support[];
  error: null | string;
  loading: {
    getSupport: boolean;
    addSupport: boolean;
    deleteSupport: boolean;
    updateSupport: boolean;
  };
};
const initialState: SupportState = {
  supportTickets: [],
  error: null,
  loading: {
    getSupport: false,
    addSupport: false,
    deleteSupport: false,
    updateSupport: false,
  },
};

const supportSlice = createSlice({
  name: "support",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupportTickets.pending, (state: SupportState) => {
        state.loading.getSupport = true;
        state.error = null;
      })
      .addCase(getSupportTickets.fulfilled, (state: SupportState, action) => {
        state.loading.getSupport = false;
        state.error = null;
        console.log(action, "ACTION");
        state.supportTickets = action.payload;
      })
      .addCase(
        getSupportTickets.rejected,
        (state: SupportState, action: any) => {
          state.loading.getSupport = false;
          handleApiMessage(action.payload.description, "error");
        }
      )
      .addCase(addSupport.pending, (state: SupportState) => {
        state.loading.addSupport = true;
        state.error = null;
      })
      .addCase(addSupport.fulfilled, (state: SupportState, action) => {
        state.loading.addSupport = false;
        state.error = null;
      })
      .addCase(addSupport.rejected, (state: SupportState, action: any) => {
        state.loading.addSupport = false;
        handleApiMessage(action.payload.description, "error");
      })
      .addCase(deleteSupport.pending, (state: SupportState) => {
        state.loading.deleteSupport = true;
        state.error = null;
      })
      .addCase(deleteSupport.fulfilled, (state: SupportState, action) => {
        state.loading.deleteSupport = false;
        state.error = null;
      })
      .addCase(deleteSupport.rejected, (state: SupportState, action: any) => {
        state.loading.deleteSupport = false;
        handleApiMessage(action.payload.description, "error");
      })
      .addCase(updateSupport.pending, (state: SupportState) => {
        state.loading.updateSupport = true;
        state.error = null;
      })
      .addCase(updateSupport.fulfilled, (state: SupportState, action) => {
        state.loading.updateSupport = false;
        state.error = null;
      })
      .addCase(updateSupport.rejected, (state: SupportState, action: any) => {
        state.loading.updateSupport = false;
        handleApiMessage(action.payload.description, "error");
      });
  },
});

// export const {} = supportSlice.actions;
export default supportSlice.reducer;
